import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { EditAutomationPage } from "@/modules/automation";
import { requireAuthAndPermission } from "@/utils";

export const Route = createFileRoute("/products/automation/$slug/edit")({
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Edit Automation Product"
        description="Edit the automated provisioning configuration for this product."
      />
      <EditAutomationPage />
    </>
  )
});
